/** Yields to the JS event loop so the host can reclaim heap after heavy work (e.g. iOS Safari). */
export function gcYield(ms = 1200) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
